export const darkSiteLevel0 = 'level0';
export const darkSiteLevel1 = 'level1';
export const darkSiteLevel2 = 'level2';
export const darkSiteLevel3 = 'level3';

export const designSystemIds = [
  'help_popup',
  'pop_up_no_buttons',
  'notification-popup',
  'search-popup',
  'vacation-message-banner',
  'notification-mobile-popup',
  'search-mobile-popup'
];
